import { Observable } from 'rxjs/Observable';
import { ActionOptionsArgs } from '../../../core/store/actions/base-actions';
import { AccountObjectStoreFacade } from '../account-object/account-object.store-facade';
import { Account } from '../account/account.model';
import { Qry } from '../query-facade';
import * as actions from './account-statistics.actions';
import { AccountStatistics } from './account-statistics.model';

export class AccountStatisticsStoreFacade extends AccountObjectStoreFacade<AccountStatistics> {
    getAll(): Observable<Array<AccountStatistics>> {
        return this.select(Qry.getInstance().accountStatistics.items);
    }

    getByAccount(account: Account): Observable<AccountStatistics> {
        return this.getAll()
            .map(items => items.find(item => item.account === account.id));
    }

    create(accountStatistics: AccountStatistics): void {
        this.dispatch(new actions.SubmitAction(accountStatistics));
    }

    insert(accountStatistics: AccountStatistics): void {
        this.dispatch(new actions.SubmitAction(accountStatistics, { persistable: true, restful: false }));
    }

    remove(accountStatistics: AccountStatistics, options?: ActionOptionsArgs): void {
        this.checkCanDelete(accountStatistics);
        this.dispatch(new actions.RemoveAction(accountStatistics, options));
    }

    update(accountStatistics: AccountStatistics): void {
        this.dispatch(new actions.SubmitAction(accountStatistics));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/account-statistics/account-statistics.store-facade.ts